/**
 * @fileoverview React message action toolbar for event feed messages.
 */

import React from 'react';

export interface MessageToolbarProps {
  onDelete?: () => void;
  onEdit?: () => void;
  onCopyError?: () => void;
  onCopySuccess?: () => void;
  rawMessagePayload?: string;
}

const MessageToolbar: React.FC<MessageToolbarProps> = ({
  onDelete,
  onEdit,
  onCopyError,
  onCopySuccess,
  rawMessagePayload = '',
}) => {
  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(rawMessagePayload);
      onCopySuccess?.();
    } catch {
      onCopyError?.();
    }
  };

  return (
    <div className="bl-message-tooltip">
      <div className="bl-message-tooltip_actions">
        <ul className="bl-message-tooltip_actions_list">
          <li className="bl-message-tooltip_actions_item">
            <button
              aria-label="Edit message"
              className="bl-message-tooltip_actions_btn"
              onClick={onEdit}
              type="button"
            >
              <span className="bl-icon-edit"></span>
            </button>
          </li>
          <li className="bl-message-tooltip_actions_item">
            <button
              aria-label="Copy message"
              className="bl-message-tooltip_actions_btn"
              onClick={handleCopy}
              type="button"
            >
              <span className="bl-icon-copy"></span>
            </button>
          </li>
          <li className="bl-message-tooltip_actions_item">
            <button
              aria-label="Delete message"
              className="bl-message-tooltip_actions_btn"
              onClick={onDelete}
              type="button"
            >
              <span className="bl-icon-trash"></span>
            </button>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default MessageToolbar;
